(function ($) {
    "use strict";
    /**Preloader*/
    $(window).preloader({
        delay: 0
    });
    //auto close navbar-collapse on click a
    $('.nav-item>[data-scroll]').on('click', function () {
        $('.navbar-toggler:visible').click();
    });
    $('#toggle').click(function() {
     $(this).toggleClass('active');
     $('#overlay').toggleClass('open');
    });

      var clicked = "false";

      $('#toggle').click(function(e) {
        e.preventDefault();
        var overflowState = 'initial'

        if (clicked == "false") {
        overflowState = 'hidden';
        clicked = "true";
        } else {
        overflowState = 'initial';
        clicked = "false";
        }
        $('html, body').css('overflow', overflowState);
      });

    // $(document).delegate("div.feature-tegel", "click", function() {
    //    window.location = $(this).find("a").attr("href");
    // });

    /*sticky navbar*/
    /**transparent header fixed-top */
    /*header shrink*/
    $(window).on("scroll",function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            $("#navbar-fixed-top").addClass("sticky-active");
            $("#navbar-sticky").sticky({ topSpacing: 0 });
        } else {
            $("#navbar-fixed-top").removeClass("sticky-active");
            //$("#navbar-sticky").sticky({ topSpacing: 0 });
        }

        $('.contact-trigger').removeClass('active');
    });
    document.body.addEventListener('click', function(e) {
        if (!e.target.classList.contains('icon-trigger')) {
            $('.contact-trigger').removeClass('active');
        }
    });

    //video in banner
    jarallax(document.querySelectorAll('.jarallax'), {
      disableParallax: function () {
          return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
      },
      disableVideo: function () {
          return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
      }
  });

    //contact widget side/bottom
    var trigger = $('.contact-widget-page'),
			overlay = $('.overlay'),
		  isClosed = false;

    	trigger.click(function () {
    		hamburger_cross();
    	});

    	function hamburger_cross() {
    		if (isClosed == true) {
    			//overlay.hide();
    			trigger.removeClass('is-open');
    			trigger.addClass('is-closed');
    			isClosed = false;
    		} else {
    			//overlay.show();
    			trigger.removeClass('is-closed');
    			trigger.addClass('is-open');
    			isClosed = true;
    		}
    	}
    	$('.contact-trigger').click(function () {
    		$('body').toggleClass('toggled');
    	});


    /*video modal*/
    $('.play-video').magnificPopup({
        type: 'iframe',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
    // Google Maps modal
    $('.popup-gmaps').magnificPopup({
  		disableOn: 700,
  		type: 'iframe',
  		mainClass: 'mfp-fade',
  		removalDelay: 160,
  		preloader: false,
  		fixedContentPos: false
  	});
    /*smooth scroll*/
    window.smoothScroll.init({
        selector: '[data-scroll]', // Selector for links (must be a class, ID, data attribute, or element tag)
        speed: 800, // Integer. How fast to complete the scroll in milliseconds
        easing: 'easeInOutCubic', // Easing pattern to use
        offset: 70, // Integer. How far to offset the scrolling anchor location in pixels
        callback: function (anchor, toggle) { } // Function to run after scrolling
    });
})(jQuery);
$(function () {
    "use strict";
    if ($('.scrollReveal').length && !$('html.ie9').length) {
        $('.scrollReveal').parent().css('overflow', 'hidden');
        window.sr = window.scrollReveal({
            reset: false,
            distance: '25px',
            mobile: false,
            duration: 850,
            scale: 1,
            viewFactor: 0.3,
            easing: 'ease-in-out'
        });
        sr.reveal('.sr-top', { origin: 'top' });
        sr.reveal('.sr-bottom', { origin: 'bottom' });
        sr.reveal('.sr-left', { origin: 'left' });
        sr.reveal('.sr-long-left', { origin: 'left', distance: '70px', duration: 1000 });
        sr.reveal('.sr-right', { origin: 'right' });
        sr.reveal('.sr-scaleUp', { scale: '0.8' });
        sr.reveal('.sr-scaleDown', { scale: '1.15' });

        sr.reveal('.sr-delay-1', { delay: 200 });
        sr.reveal('.sr-delay-2', { delay: 400 });
        sr.reveal('.sr-delay-3', { delay: 600 });
        sr.reveal('.sr-delay-4', { delay: 800 });
        sr.reveal('.sr-delay-5', { delay: 1000 });
        sr.reveal('.sr-delay-6', { delay: 1200 });
        sr.reveal('.sr-delay-7', { delay: 1400 });
        sr.reveal('.sr-delay-8', { delay: 1600 });

        sr.reveal('.sr-ease-in-out-quad', { easing: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)' });
        sr.reveal('.sr-ease-in-out-cubic', { easing: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)' });
        sr.reveal('.sr-ease-in-out-quart', { easing: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)' });
        sr.reveal('.sr-ease-in-out-quint', { easing: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)' });
        sr.reveal('.sr-ease-in-out-sine', { easing: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)' });
        sr.reveal('.sr-ease-in-out-expo', { easing: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)' });
        sr.reveal('.sr-ease-in-out-circ', { easing: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)' });
        sr.reveal('.sr-ease-in-out-back', { easing: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)' });
    }
});

// Mouseover/ Click sound effect- by JavaScript Kit (www.javascriptkit.com)
// Visit JavaScript Kit at http://www.javascriptkit.com/ for full source code

//** Usage: Instantiate script by calling: var uniquevar=createsoundbite("soundfile1", "fallbackfile2", "fallebacksound3", etc)
//** Call: uniquevar.playclip() to play sound

var html5_audiotypes={ //define list of audio file extensions and their associated audio types. Add to it if your specified audio file isn't on this list:
	"mp3": "audio/mpeg",
	"mp4": "audio/mp4",
	"ogg": "audio/ogg",
	"wav": "audio/wav"
}

function createsoundbite(sound){
	var html5audio=document.createElement('audio')
	if (html5audio.canPlayType){ //check support for HTML5 audio
		for (var i=0; i<arguments.length; i++){
			var sourceel=document.createElement('source')
			sourceel.setAttribute('src', arguments[i])
			if (arguments[i].match(/\.(\w+)$/i))
				sourceel.setAttribute('type', html5_audiotypes[RegExp.$1])
			html5audio.appendChild(sourceel)
		}
		  html5audio.load()
		  html5audio.playclip=function(){
			html5audio.pause()
			html5audio.currentTime=0
			html5audio.play()
		}
		return html5audio
	}
	else{
		return {playclip:function(){throw new Error("Your browser doesn't support HTML5 audio unfortunately")}}
	}
}

//Initialize two sound clips with 1 fallback file each:

//var mouseoversound=createsoundbite("http://www.cartelle.nl/media/audio/tick.ogg", "http://www.cartelle.nl/media/audio/tick.mp3")
//var clicksound=createsoundbite("http://www.ultranoir.com/cdn/gene/sound/clack.ogg", "http://www.ultranoir.com/cdn/gene/sound/clack.m4a")
